/**
 * `YYYY-MM` month-key maths for the jobs views (board, split, planner).
 *
 * Moved out of JobsToolbar.jsx: a presentational component is not where date maths
 * belongs, and while it lived there it could not be imported by anything that did not
 * also want React and a toolbar. The functions are unchanged.
 *
 * ⚠️ Related, and NOT yet merged: `utils/monthRange.js` does the same job for the
 * customers browse under different names (`currentMonthValue`, `shiftMonth`,
 * `rangeFromMonth`). Two month implementations is one too many — whichever of the two
 * you are next in, converge them rather than adding a third.
 *
 * The month is carried as a plain `YYYY-MM` string rather than an offset from now:
 * that is what `<input type="month">` reads and writes, and it stays correct if a
 * screen is left open across midnight on the 1st, where an offset would quietly start
 * meaning a different month than the one on display.
 */

/** The current month as `YYYY-MM`, in LOCAL time. */
export const currentMonthKey = () => {
    const d = new Date();
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
};

/** First day of the given YYYY-MM month, as ISO yyyy-MM-dd. */
export const monthFromDate = (monthKey) => `${monthKey}-01`;

/** Last day of the given YYYY-MM month, as ISO yyyy-MM-dd (handles leap years). */
export const monthToDate = (monthKey) => {
    const [y, m] = monthKey.split('-').map(Number);
    const lastDay = new Date(y, m, 0).getDate();
    return `${monthKey}-${String(lastDay).padStart(2, '0')}`;
};

/** Step a YYYY-MM key by ±N months. */
export const shiftMonthKey = (monthKey, delta) => {
    const [y, m] = monthKey.split('-').map(Number);
    const d = new Date(y, m - 1 + delta, 1);
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
};

/** Pretty label — e.g. "November 2025". */
export const formatMonthLabel = (monthKey) => {
    const [y, m] = monthKey.split('-').map(Number);
    return new Date(y, m - 1, 1).toLocaleDateString('en-AU', { month: 'long', year: 'numeric' });
};
